import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api-client';

export const auditLogKeys = {
  all: ['audit-logs'] as const,
  list: (params?: AuditLogsParams) => [...auditLogKeys.all, 'list', params] as const,
};

interface AuditLogResponse {
  id: string;
  adminId: number;
  actionType: string;
  entityType: string;
  entityId: string;
  metadata: Record<string, unknown> | null;
  createdAt: string;
}

interface PaginatedAuditLogs {
  data: AuditLogResponse[];
  meta: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

interface AuditLogsParams {
  page?: number;
  limit?: number;
  adminId?: number;
  actionType?: string;
  entityType?: string;
  entityId?: string;
  startDate?: string;
  endDate?: string;
}

export function useAuditLogs(params?: AuditLogsParams) {
  const queryParams = new URLSearchParams();
  if (params?.page) queryParams.set('page', params.page.toString());
  if (params?.limit) queryParams.set('limit', params.limit.toString());
  if (params?.adminId) queryParams.set('adminId', params.adminId.toString());
  if (params?.actionType) queryParams.set('actionType', params.actionType);
  if (params?.entityType) queryParams.set('entityType', params.entityType);
  if (params?.entityId) queryParams.set('entityId', params.entityId);
  if (params?.startDate) queryParams.set('startDate', params.startDate);
  if (params?.endDate) queryParams.set('endDate', params.endDate);

  const queryString = queryParams.toString();
  const url = `/api/v1/audit-logs${queryString ? `?${queryString}` : ''}`;

  return useQuery({
    queryKey: auditLogKeys.list(params),
    queryFn: () => api.get<PaginatedAuditLogs>(url),
  });
}

export type { AuditLogResponse, AuditLogsParams };
